export const getVimeoId = (url?: string) =>
  url ? url.split("https://vimeo.com/")?.[1]?.split("/")?.[0] : "";

export const getVimeoIdHash = (url?: string) =>
  url ? url.split("https://vimeo.com/")?.[1]?.split("/")?.[1] : "";
